// extracted by mini-css-extract-plugin
export default {"departments":"KI-z","departmentHeading":"LI-z","departmentSection":"MI-z","departmentName":"NI-z","departmentLink":"OI-z","expandIcon":"PI-z"};